/**
 * 微信 UA 检测与复制辅助
 */

export function isWeChatBrowser(ua = typeof navigator !== 'undefined' ? navigator.userAgent : '') {
  return /MicroMessenger/i.test(ua || '');
}

export async function copyText(text) {
  const value = String(text || '');
  if (!value) return false;
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    /* fallthrough */
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = value;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

/** 关系事实向分享话术（禁止聊天内容） */
export function buildRelationShareText({ title, circleName, link, slogan } = {}) {
  const lines = [
    circleName ? `「${circleName}」${title || '关系卡片'}` : `朋际 · ${title || '给自己人看'}`,
    slogan || '微信给全世界看，朋际给自己人看。',
    '想进来？先候补 / 找已在用的朋友要邀请。',
  ];
  if (link) lines.push(link);
  return lines.join('\n');
}
